'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Mute = require('./Actions/Mute');

var _Mute2 = _interopRequireDefault(_Mute);

var _Pause = require('./Actions/Pause');

var _Pause2 = _interopRequireDefault(_Pause);

var _Play = require('./Actions/Play');

var _Play2 = _interopRequireDefault(_Play);

var _SetCurrentTime = require('./Actions/SetCurrentTime');

var _SetCurrentTime2 = _interopRequireDefault(_SetCurrentTime);

var _setCurrentTimeMs = require('./Actions/setCurrentTimeMs');

var _setCurrentTimeMs2 = _interopRequireDefault(_setCurrentTimeMs);

var _SetContextMenu = require('./Actions/SetContextMenu');

var _SetContextMenu2 = _interopRequireDefault(_SetContextMenu);

var _SetPlaybackRate = require('./Actions/SetPlaybackRate');

var _SetPlaybackRate2 = _interopRequireDefault(_SetPlaybackRate);

var _SetPlayingIndex = require('./Actions/SetPlayingIndex');

var _SetPlayingIndex2 = _interopRequireDefault(_SetPlayingIndex);

var _SetSeeking = require('./Actions/SetSeeking');

var _SetSeeking2 = _interopRequireDefault(_SetSeeking);

var _SetQuality = require('./Actions/SetQuality');

var _SetQuality2 = _interopRequireDefault(_SetQuality);

var _SetVolume = require('./Actions/SetVolume');

var _SetVolume2 = _interopRequireDefault(_SetVolume);

var _ToggleFullscreen = require('./Actions/ToggleFullscreen');

var _ToggleFullscreen2 = _interopRequireDefault(_ToggleFullscreen);

var _RestartPlayables = require('./Actions/RestartPlayables');

var _RestartPlayables2 = _interopRequireDefault(_RestartPlayables);

var _Loop = require('./Actions/Loop');

var _Loop2 = _interopRequireDefault(_Loop);

var _StopLoop = require('./Actions/StopLoop');

var _StopLoop2 = _interopRequireDefault(_StopLoop);

var _InsertPlayable = require('./Actions/InsertPlayable');

var _InsertPlayable2 = _interopRequireDefault(_InsertPlayable);

var _RemovePlayable = require('./Actions/RemovePlayable');

var _RemovePlayable2 = _interopRequireDefault(_RemovePlayable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _actions = {
  mute: _Mute2.default,
  pause: _Pause2.default,
  play: _Play2.default,
  setCurrentTime: _SetCurrentTime2.default,
  setCurrentTimeMs: _setCurrentTimeMs2.default,
  setContextMenu: _SetContextMenu2.default,
  setPlaybackRate: _SetPlaybackRate2.default,
  setPlayingIndex: _SetPlayingIndex2.default,
  setQuality: _SetQuality2.default,
  setSeeking: _SetSeeking2.default,
  setVolume: _SetVolume2.default,
  toggleFullscreen: _ToggleFullscreen2.default,
  restartPlayables: _RestartPlayables2.default,
  loop: _Loop2.default,
  stopLoop: _StopLoop2.default,
  insertPlayable: _InsertPlayable2.default,
  removePlayable: _RemovePlayable2.default
}; /**
    * Copyright 2013-2015, Hudl
    * All rights reserved.
    *
    * This source code is licensed under the BSD-style license found in the
    * LICENSE file in the root directory of this source tree. An additional grant
    * of patent rights can be found in the PATENTS file in the same directory.
    *
    * @providesModule VideoActions
    */

var DEFAULT_ACTION_KEYS = Object.keys(_actions);

exports.default = {
  get actions() {
    return _actions;
  },

  addAction: function addAction(name, actionFunction) {
    _actions[name] = actionFunction;
  },
  removeActionByName: function removeActionByName(name) {
    if (DEFAULT_ACTION_KEYS.indexOf(name) === -1) {
      delete _actions[name];
    }
  }
};
module.exports = exports['default'];